import styled from "vue-styled-components";


export const CPromotionContainer = styled.div`
    position: relative;
    padding-top: 4rem;
    padding-bottom: 4rem;
    height: 280px;
    border-bottom: 4px solid ${props => props.theme.primary_color};
    border-top: 4px solid ${props => props.theme.primary_color};
    display:flex;
    overflow:hidden;

    > div {
        display:flex;
        max-width: 1040px;
        margin-left: auto;
        margin-right: auto;
    }

    @media (max-width: 1040px){
        height: 280px;

        > div {
            width:800px;
        }
    }

    @media (max-width: 768px){
        height: 280px;

        >div{
        width:500px;
        }
    }

    @media (max-width: 411px){
        height: 280px;

        > div {
            width:405px;
        }
    }


`;

export const CProductPromotion = styled.div`
    width: 200px;
    height: 200px;
    border: 1px solid ${props => props.theme.primary_color};
    display:flex;
    align-items:center;
    justify-content: center;
    background-color:#fff;
    transition: border-radius .5s, box-shadow .5s;
    position:relative;
    &:hover {
        border-radius: 10px;
        box-shadow: inset 0 0 1em #ccc, 0 0 1em ${props => props.theme.primary_color};
    }

    > img {
        display:flex;
        align-items:center;
        justify-content:center;
        width: 150px;
        height: auto;
    }
    > span {
        display:flex;
        align-items:center;
        padding-left: 5px;
        position:absolute;
        left:0px;
        bottom:10px;
        height: 35px;
        width: 160px;
        background-color: ${props => props.theme.primary_color};
        font-size: 10px;
        color: #fff;
    }
    > span > p {
        text-decoration:line-through;
        align-items:center;
    }
    > span > strong {
        padding-left: 5px;
        font-size:16px;
    }

    @media (max-width: 581px) {
        width: 150px;
        height: 150px;

        > img {
            width: 100px;
            height: auto;
        }
        > span {
            width: 100px;
        }

        > span > strong {
            padding-left: 5px;
            font-size:14px;
        }
    }

    @media (max-width: 360px) {
        width: 200px;
        height: 200px;

        > img {
            width: 150px;
            height: auto;
        }
        > span {
            width: 160px;
        }

        > span > strong {
            padding-left: 5px;
            font-size:16px;
        }
    }
`;